import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {useEffect, useState} from 'react'
import {addressForServiceSelect} from '../../redux/selector/addressForServiceSelector'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    ErrorWithString,
    ErrorMark
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
} from '../../app/constants'
import { replaceUrlParams, ValidateString } from '../../app/utils';
import Navigation from '../Navigation';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors';
import { setAgencyAddressForService } from '../../redux/slice/primaryAgencyApplicationSlice';

const AddressForService = (props) => {
    const {addressForService} = props
    const {applicationType,applicationMode} = props.match.params
    
    let address = "", city = "", postalCode = ""

    if(addressForService.serviceCivicAddress && 
        addressForService.serviceCivicAddress.street) { 
            address = addressForService.serviceCivicAddress.street
            city = addressForService.serviceCivicAddress.city
            postalCode = addressForService.serviceCivicAddress.postalCode
    }

    const [addressText, setAddressText] = useState(address)
    const [cityText, setCityText] = useState(city)
    const [postalCodeText, setPostalCodeText] = useState(postalCode)

    useEffect(() => {
        let address = "", city = "", postalCode = ""

        if(addressForService.serviceCivicAddress && 
            addressForService.serviceCivicAddress.street) { 
                address = addressForService.serviceCivicAddress.street
                city = addressForService.serviceCivicAddress.city
                postalCode = addressForService.serviceCivicAddress.postalCode
        } 
        setAddressText(address)
        setCityText(city)
        setPostalCodeText(postalCode)
    }, [
        addressForService.serviceCivicAddress,
        setAddressText,
        setCityText,
        setPostalCodeText
    ])
    
    const [addressValidationError, setAddressValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [cityValidationError, setCityValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [postalCodeValidationError, setPostalCodeValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const [showValidationError, setShowValidationError] = useState(false)

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR)) 

    const validateData = () => { 
        const ret1 = ValidateString(addressText, VALIDATION_TYPE.CIVIC_ADDRESS)
        setAddressValidationError(ret1)

        const ret2 = ValidateString(cityText, VALIDATION_TYPE.STRING_NON_EMPTY)
        setCityValidationError(ret2)

        const ret3 = ValidateString(postalCodeText, VALIDATION_TYPE.CANADA_POSTAL_CODE)
        setPostalCodeValidationError(ret3)

        return (ret1 === VALIDATION_ERROR.NO_ERROR 
                && ret2 === VALIDATION_ERROR.NO_ERROR 
                && ret3 === VALIDATION_ERROR.NO_ERROR)
    }

    const isAddressValid = () => { 
        if(showValidationError) {
            return addressValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const isCityValid = () => { 
        if(showValidationError) { 
            return cityValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const isPostalCodeValid = () => { 
        if(showValidationError) { 
            return postalCodeValidationError === VALIDATION_ERROR.NO_ERROR
        }

        return true
    }

    const addressErrorString = () => { 
        if(addressValidationError !== VALIDATION_ERROR.NO_ERROR) {
            return "Enter a street address in Nova Scotia"
        }

        return null
    }

    const cityErrorString = () => { 
        if(cityValidationError !== VALIDATION_ERROR.NO_ERROR) {
            return "Enter a city/town"
        }

        return null
    }

    const postalCodeErrorString = () => { 
        if(postalCodeValidationError === VALIDATION_ERROR.EMPTY) {
            return "Enter a postal code"
        } else if(postalCodeValidationError === VALIDATION_ERROR.CANADA_POSTAL_CODE_INVALID) { 
            return "Enter valid postal code"
        } else if(postalCodeValidationError !== VALIDATION_ERROR.NO_ERROR) { 
            return "Enter a postal code"
        }

        return null
    }

    const onSaveAndNext = () => {
        
        setApplicationSaveError(false)

        if(!validateData()) {
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        props.dispatch(setAgencyAddressForService({
            street : addressText,
            city: cityText,
            postalCode : postalCodeText
        }))

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                props.dispatch(push(replaceUrlParams(addressForService.navigation.next, applicationType, applicationMode)))
            })  
            .catch(err => {
                setApplicationSaveError(true)
            })      
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <TopNavigationBar {...props}/>
                    <div className="row bottomMarginNormal">
                        <div className="col-lg-8">
                            <Header 
                                id={'address-for-service-header'} 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? addressForService.headerRenewal : addressForService.header} />
                            <Paragraph 
                                id={'address-for-service-text'} 
                                text={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? addressForService.textRenewal : addressForService.text} />
                        </div>
                    </div>
                </>
                }
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">

                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                            <ReviewForm data={{
                                "Street address" : addressText,
                                "City/Town" : cityText,
                                "Postal code" : postalCodeText
                            }} />
                        }

                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                            <fieldset className="ns-fieldset">
                                <div className={"ns-fieldset" + (!isAddressValid() ? " ns-fieldset-message-error" : "")}>
                                    <label
                                        className="ns-label"
                                        htmlFor={'address-for-service-form-address-text'}
                                        id={"address-for-service-form-address-label"}>
                                            {addressForService.addressTextHeader}
                                    </label>
                                    {!isAddressValid() && 
                                    <span id={"address-for-service-form-address-error"} className="ns-error-message field-validation-error">
                                        {ErrorWithString(addressErrorString())}
                                    </span>
                                    }
                                    <input 
                                        id={"address-for-service-form-address-text"} 
                                        name={"address-for-service-form-address-text"} 
                                        className={"fw-20" + (isAddressValid() ? " ns-input" : " ns-input--error")}
                                        autoComplete="street-address" 
                                        type={"text"} 
                                        value={addressText} 
                                        onInput={(e) => {
                                            setAddressValidationError(VALIDATION_ERROR.NO_ERROR)
                                            setAddressText(e.target.value)
                                        }} 
                                        style={{width: "350px"}} />
                                </div>

                                <div className={"ns-fieldset" + (!isCityValid() ? " ns-fieldset-message-error" : "")}>
                                    <label
                                        className="ns-label"
                                        htmlFor={'address-for-service-form-city-text'}
                                        id={"address-for-service-form-city-label"}>
                                            {addressForService.cityTextHeader}
                                    </label>
                                    {!isCityValid() && 
                                    <span id={"address-for-service-form-city-error"} className="ns-error-message field-validation-error">
                                        {ErrorWithString(cityErrorString())}
                                    </span>}
                                    <input 
                                        id={"address-for-service-form-city-text"} 
                                        name={"address-for-service-form-city-text"}
                                        className={"fw-20" + (isCityValid() ? " ns-input" : " ns-input--error")}
                                        autoComplete="address-level2" 
                                        type={"text"} 
                                        value={cityText} 
                                        onInput={(e) => {
                                            setCityValidationError(VALIDATION_ERROR.NO_ERROR)
                                            setCityText(e.target.value)
                                        }} 
                                        style={{width: "350px"}} />
                                </div>

                                <div className={"ns-fieldset" + (!isPostalCodeValid() ? " ns-fieldset-message-error" : "")}>
                                    <label
                                        className="ns-label"
                                        htmlFor={'address-for-service-form-postalcode-text'}
                                        id={"address-for-service-form-postalcode-label"}>
                                            {addressForService.postalCodeTextHeader}
                                    </label>
                                    {!isPostalCodeValid() &&
                                    <span id="address-for-service-form-postalcode-error" className="ns-error-message field-validation-error">
                                        {ErrorWithString(postalCodeErrorString())}
                                    </span>}
                                    <input 
                                        id={"address-for-service-form-postalcode-text"} 
                                        name={"address-for-service-form-postalcode-text"}
                                        className={"fw-20" + (isPostalCodeValid() ? " ns-input" : " ns-input--error")}
                                        autoComplete="postal-code" 
                                        type={"text"} 
                                        value={postalCodeText} 
                                        onInput={(e) => {
                                            setPostalCodeValidationError(VALIDATION_ERROR.NO_ERROR)
                                            setPostalCodeText(e.target.value)
                                        }} 
                                        style={{width: "350px"}} />
                                </div>
                            </fieldset> 
                        }
                    </div>
                </div>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id={"address-for-service-save-next"}
                                onClick={onSaveAndNext}
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && 
                            <div className="ns-error-message help-block topMarginNormal">
                                <span className="ns-visually-hidden">Error:</span>
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"address-for-service-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => {
                                    setViewMode(VIEW_MODE_RENEWAL_EDIT)
                                }}
                            />
                        </div>}
                    </div>
                </>
                }
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className="col-lg-6">
                            <Button 
                                id={"address-for-service-edit-mode-save"}
                                onClick={() => {
                                    if(!validateData()) { 
                                        setShowValidationError(true)
                                        return
                                    }
                            
                                    setShowValidationError(false)

                                    props.dispatch(setAgencyAddressForService({
                                        street : addressText,
                                        city: cityText,
                                        postalCode : postalCodeText
                                    }))
                                    props.onEditSave()
                                }}
                                text={"Save"}
                                buttonType={"regular_primary"}
                            />
                        </div>
                    </div>
                </>
                }
            </div>
        </>
    )
}

export default connect(addressForServiceSelect)(AddressForService)
